import styled, { css } from 'styled-components';

export const QuickSearchInput = styled.input.attrs(() => ({
  className: 'form-control',
}))`
  border-color: var(--neutral-200);
  padding-right: 36px;
`;

export const QuickSearchIcon = styled.i`
  display: inline-grid !important;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 1em;
  height: 1em;
  vertical-align: middle;
  position: absolute;
  right: 0.5rem;
  top: 50%;
  margin-top: -8px;
  color: var(--neutral-400);
  cursor: pointer;
  & > svg {
    fill: currentColor;
    stroke: currentColor;
    shape-rendering: geometricPrecision;
    height: 1em;
  }
  & > svg path {
    shape-rendering: geometricPrecision;
  }
  ${({ size }) =>
    size &&
    css`
      width: ${size}px;
      height: ${size}px;
      & > svg {
        height: ${size}px;
      }
    `}
  ${({ color }) =>
    color &&
    css`
      color: var(--${color});
    `}
`;

export const QuickSearchContainer = styled.div`
  position: relative;
  ${(props) =>
    !props.hasValue &&
    css`
      ${QuickSearchIcon} {
        display: none !important;
      }
    `}
`;
